// extracted by mini-css-extract-plugin
export default {"subtitle":"ThankYou_subtitle__RKfFI","thankYou":"ThankYou_thankYou__mU7dq"};